/**
 * DPR CUSTOMER-SPECIFIC CALENDAR HEADER FIX
 * Addresses av-header-info-week not updating consistently when calendar dates change
 * ONLY applies to DPR site (https://dpr.capstonesystem.com.au)
 */

(function() {
    'use strict';
    
    // Only apply this fix on DPR customer site
    if (!window.location.hostname.includes('dpr.capstonesystem.com.au')) {
        console.log('📋 Calendar fix: Not DPR site, skipping');
        return;
    }
    
    console.log('🔧 DPR Calendar Header Fix v1.0 - Initializing...'); 
    
    let isFixActive = false;
    let headerUpdateAttempts = 0;
    let calendarClickCount = 0;
    
    /**
     * Enhanced header update function with multiple retry strategies
     */
    function forceHeaderUpdate() {
        const headerElement = document.querySelector('.av-header-info-week') || 
                             document.querySelector('[class*="header-info-week"]') ||
                             document.querySelector('[class*="week-info"]') ||
                             document.querySelector('.week-header');
        
        if (!headerElement) {
            console.log('⚠️ Header element not found, trying alternative selectors...');
            // Try broader selectors
            const allHeaderElements = document.querySelectorAll('[class*="header"]');
            const weekElements = document.querySelectorAll('[class*="week"]');
            console.log('🔍 Found header elements:', allHeaderElements.length);
            console.log('🔍 Found week elements:', weekElements.length);
            return false;
        }
        
        headerUpdateAttempts++;
        console.log(`🎯 Attempting header update #${headerUpdateAttempts}`);
        
        try {
            // Strategy 1: Angular change detection
            if (typeof ng !== 'undefined') {
                const headerComponent = ng.getComponent(headerElement);
                if (headerComponent) {
                    console.log('🔄 Applying Angular change detection...');
                    ng.applyChanges(headerComponent);
                    
                    // Try component-specific update methods
                    if (headerComponent.updateWeekInfo && typeof headerComponent.updateWeekInfo === 'function') {
                        headerComponent.updateWeekInfo();
                    }
                    if (headerComponent.refresh && typeof headerComponent.refresh === 'function') {
                        headerComponent.refresh();
                    }
                    if (headerComponent.ngOnInit && typeof headerComponent.ngOnInit === 'function') {
                        headerComponent.ngOnInit();
                    }
                }
            }
            
            // Strategy 2: Manual DOM refresh
            const originalDisplay = headerElement.style.display;
            const originalVisibility = headerElement.style.visibility;
            
            headerElement.style.display = 'none';
            headerElement.offsetHeight; // Force reflow
            headerElement.style.display = originalDisplay;
            
            // Strategy 3: Trigger custom events
            headerElement.dispatchEvent(new CustomEvent('forceUpdate', { bubbles: true }));
            window.dispatchEvent(new CustomEvent('calendarDateChanged', {
                detail: {
                    timestamp: new Date().toISOString(),
                    source: 'dpr-calendar-fix'
                },
                bubbles: true
            }));
            
            // Strategy 4: Parent component update
            const parentElement = headerElement.parentElement;
            if (parentElement && typeof ng !== 'undefined') {
                const parentComponent = ng.getComponent(parentElement);
                if (parentComponent) {
                    ng.applyChanges(parentComponent);
                }
            }
            
            console.log('✅ Header update strategies applied');
            return true;
            
        } catch (error) {
            console.error('❌ Error in header update:', error);
            return false;
        }
    }
    
    /**
     * Enhanced calendar click detection with retry logic
     */
    function setupCalendarClickMonitoring() {
        document.addEventListener('click', function(event) {
            const target = event.target;
            const isCalendarClick = target.closest('[ng-c9432080]') || 
                                   target.closest('.calendar') ||
                                   target.closest('[class*="calendar"]') ||
                                   target.closest('[class*="date-picker"]') ||
                                   target.closest('[class*="date-selector"]');
            
            if (isCalendarClick) {
                calendarClickCount++;
                console.log(`🗓️ Calendar click #${calendarClickCount} detected:`, {
                    element: target.tagName,
                    classes: target.classList.toString(),
                    text: target.textContent?.substring(0, 50)
                });
                
                // Apply fix with multiple timing attempts
                setTimeout(() => forceHeaderUpdate(), 10);   // Immediate
                setTimeout(() => forceHeaderUpdate(), 50);   // Fast follow-up
                setTimeout(() => forceHeaderUpdate(), 150);  // Medium delay
                setTimeout(() => forceHeaderUpdate(), 300);  // Slower fallback
                
                // Final validation check
                setTimeout(() => {
                    const headerElement = document.querySelector('.av-header-info-week');
                    if (headerElement) {
                        console.log('📊 Final header state check:', {
                            text: headerElement.textContent,
                            visible: headerElement.offsetWidth > 0 && headerElement.offsetHeight > 0,
                            display: window.getComputedStyle(headerElement).display
                        });
                    }
                }, 500);
            }
        }, true); // Use capture phase for better timing
        
        console.log('👂 Calendar click monitoring active');
    }
    
    /**
     * Setup mutation observer for header element changes
     */
    function setupHeaderChangeMonitoring() {
        const checkForHeader = () => {
            const headerElement = document.querySelector('.av-header-info-week');
            if (headerElement && !headerElement.hasAttribute('data-dpr-fix-monitored')) {
                headerElement.setAttribute('data-dpr-fix-monitored', 'true');
                
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        if (mutation.type === 'childList' || mutation.type === 'characterData') {
                            console.log('📝 Header content changed:', {
                                newText: headerElement.textContent,
                                mutationType: mutation.type,
                                timestamp: new Date().toISOString()
                            });
                        }
                    });
                });
                
                observer.observe(headerElement, {
                    childList: true,
                    subtree: true,
                    characterData: true
                });
                
                console.log('👁️ Header change monitoring active');
                return true;
            }
            return false;
        };
        
        // Try to find header immediately
        if (!checkForHeader()) {
            // If not found, try again after DOM changes
            const bodyObserver = new MutationObserver(() => {
                if (checkForHeader()) {
                    bodyObserver.disconnect();
                }
            });
            
            bodyObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
    }
    
    /**
     * Initialize the fix when Angular is ready
     */
    function initializeWhenReady() {
        if (typeof ng !== 'undefined' && !isFixActive) {
            isFixActive = true;
            
            console.log('🎯 Angular detected, activating DPR calendar fix');
            
            setupCalendarClickMonitoring();
            setupHeaderChangeMonitoring();
            
            // Add global test function
            window.testDPRCalendarFix = function() {
                console.log('🧪 Testing DPR Calendar Fix...');
                return forceHeaderUpdate();
            };
            
            // Add global status function
            window.getDPRCalendarFixStatus = function() {
                return {
                    active: isFixActive,
                    clickCount: calendarClickCount,
                    updateAttempts: headerUpdateAttempts,
                    headerElement: !!document.querySelector('.av-header-info-week'),
                    angularAvailable: typeof ng !== 'undefined'
                };
            };
            
            console.log('✅ DPR Calendar Header Fix v1.0 - ACTIVE');
            console.log('📋 Available commands: testDPRCalendarFix(), getDPRCalendarFixStatus()');
            
        } else if (!isFixActive) {
            // Angular not ready yet, try again
            setTimeout(initializeWhenReady, 100);
        }
    }
    
    // Start initialization
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeWhenReady);
    } else {
        initializeWhenReady();
    }
    
})();
